import { useEffect, useRef } from "react";
import { gsap, ScrollTrigger, prefersReducedMotion } from "@/lib/animations";

export const StepsTimeline = ({ product }) => {
  const listRef = useRef(null);
  const lineRef = useRef(null);

  useEffect(() => {
    if (prefersReducedMotion()) return;
    const tween = gsap.fromTo(
      lineRef.current,
      { scaleY: 0 },
      {
        scaleY: 1,
        ease: "none",
        transformOrigin: "top",
        scrollTrigger: { trigger: listRef.current, start: "top 70%", end: "bottom 65%", scrub: 0.4 },
      }
    );
    return () => {
      tween.scrollTrigger?.kill();
      tween.kill();
    };
  }, []);

  useEffect(() => () => ScrollTrigger.refresh(), []);

  return (
    <section id="how-it-works" className="bg-white border-y border-[#0B132B]/6 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <p data-reveal className="text-sm tracking-[0.2em] uppercase text-[#29ABE2] font-semibold mb-4">
              How it works
            </p>
            <h2
              data-reveal
              className="font-heading font-black text-4xl sm:text-5xl tracking-tighter leading-[0.95] text-[#0B132B]"
            >
              Three moves. <br className="hidden sm:block" />
              One plan for life.
            </h2>
            <p data-reveal className="mt-6 text-base md:text-lg text-[#334155] font-light leading-relaxed max-w-md">
              {product.howItWorks}
            </p>
          </div>
        </div>
        <div ref={listRef} className="lg:col-span-7 relative pl-14 sm:pl-20">
          <div className="absolute left-[22px] sm:left-[30px] top-3 bottom-3 w-px bg-[#0B132B]/10" aria-hidden="true" />
          <div
            ref={lineRef}
            className="absolute left-[22px] sm:left-[30px] top-3 bottom-3 w-px bg-breeze-gradient"
            aria-hidden="true"
          />
          <ol className="space-y-8 md:space-y-12">
            {product.funnel.steps.map((s, i) => (
              <li key={i} data-reveal data-testid={`step-${i + 1}`} className="relative">
                <span className="absolute -left-14 sm:-left-20 top-0 w-11 h-11 sm:w-[60px] sm:h-[60px] rounded-full bg-[#0B132B] text-white font-heading font-black text-base sm:text-xl flex items-center justify-center ring-4 ring-white shadow-lg shadow-[#0B132B]/20">
                  {i + 1}
                </span>
                <div className="rounded-3xl bg-[#F9F6F0] border border-[#0B132B]/5 p-6 md:p-8 transition-colors duration-300 hover:border-[#29ABE2]/40">
                  <h3 className="font-heading font-bold text-xl md:text-2xl tracking-tight text-[#0B132B]">{s.title}</h3>
                  <p className="mt-3 text-sm md:text-base text-[#334155] font-light leading-relaxed">{s.body}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
